module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/battle//bg.jpg?v=822e2899";